import { render, staticRenderFns } from "./welcome-info.vue?vue&type=template&id=0100c985"
import script from "./welcome-info.vue?vue&type=script&lang=js"
export * from "./welcome-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports